import * as ApiManager from './_manager';

export const consumer = {
  changePassword: payload => {
    return ApiManager.callApi ('/consumer/changePassword', payload);
  },
  purchaseScreeningOrGroupTicket: payload => {
    return ApiManager.callApi (
      '/consumer/purchase/screeningOrGroupTicket',
      payload
    );
  },
  enrollToScreening: payload => {
    return ApiManager.callApi ('/consumer/enroll', payload);
  },
  listScreenings: payload => {
    return ApiManager.callApi ('/consumer/listScreenings', payload);
  },
  listGroupPurchases: payload => {
    return ApiManager.callApi ('/consumer/listGroupPurchases', payload);
  },
  updateLiveCounter: payload => {
    return ApiManager.callApi ('/consumer/update/live_counter', payload);
  },
  redeemCoupon: payload => {
    return ApiManager.callApi ('/coupon/check_coupon', payload);
  },
  verifyShortCode: payload => {
    return ApiManager.callApi ('/consumer/verify_short_code', payload);
  },

  sendSupportRequest: payload => {
    return ApiManager.callApi ('/consumer/support', payload);
  },
  update: payload => {
    return ApiManager.callApi (`/consumer/update/profile`, payload);
  },

  subscribeNewsletter: payload => {
    return ApiManager.callApi('/consumer/subscribeNewsletter', payload);
  },

  isAlive: payload => {
    return ApiManager.callApi('/consumer/alive',payload);
  },
  listPhysicalEventBookings : payload => {
    return ApiManager.callApi('/consumer/listPhysicalEventBookings',payload);
  },
  createCancellationRequest : payload => {
    return ApiManager.callApi('/consumer/createCancellationRequest',payload);
  },
  getLockedBooking: payload => {
    return ApiManager.callApi('/consumer/getLockedBooking',payload);
  },
  markPurchaseProcessing: payload => {
    return ApiManager.callApi (
      '/consumer/purchase/markProcessing',
      payload
    );
  },
  submitRefundModificationRequest : payload => {
    return ApiManager.callApi (
      '/consumer/purchase/submitRefundModificationRequest',
      payload
    );
  }
};
